<div class="container-fluid" id="mainContainer">

    <div class="row align-items-center headingRow">
        <div class="col-md-6" id="leftCol">
            <div class="Heading">
                Settings
            </div>

        </div>
        <div *ngIf="false" class="col-4 text-right" id="btn-reg-add">
            <button routerLink="/register" type="button" class="createBtn">Register</button>
        </div>
    </div>

    <div style="display: flex; justify-content: space-between;">
        <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
            <li class="nav-item">
                <a (click)="onGeneralClick()" class="nav-link active" id="pills-general-tab" data-toggle="pill"
                    href="#pills-general" role="tab" aria-controls="pills-general" aria-selected="true">General</a>
            </li>
            <li class="nav-item">
                <a (click)="onIntClick()" class="nav-link" id="pills-integrations-tab" data-toggle="pill"
                    href="#pills-integrations" role="tab" aria-controls="pills-integrations"
                    aria-selected="false">Integrations</a>
            </li>
            <li class="nav-item">
                <a (click)="onPOSClick()" class="nav-link" id="pills-pos-tab" data-toggle="pill" href="#pills-pos"
                    role="tab" aria-controls="pills-pos" aria-selected="false">POS</a>
            </li>
            <li class="nav-item">
                <a (click)="onOrderActionClick()" class="nav-link" id="pills-oder-action-tab" data-toggle="pill"
                    href="#pills-oder-action" role="tab" aria-controls="pills-oder-action" aria-selected="false">Order
                    Settings</a>
            </li>
        </ul>

    </div>

    <div class="tab-content" id="pills-tabContent">
        <!-- Account Details Starts  Here -->
        <div class="tab-pane fade show active" id="pills-general" role="tabpanel" aria-labelledby="pills-general-tab">
            <app-account-info ></app-account-info>
        </div>


        <!-- Intergations Starts  Here -->
        <div class="tab-pane fade" id="pills-integrations" role="tabpanel" aria-labelledby="pills-integrations-tab">
            <app-integration-info></app-integration-info>
        </div>

        <!-- POS Intergations Starts  Here -->
        <div class="tab-pane fade" id="pills-pos" role="tabpanel" aria-labelledby="pills-pos-tab">
            <app-pos-integration-info></app-pos-integration-info>
        </div>

        <!-- Order actions Starts  Here -->
        <div class="tab-pane fade" id="pills-oder-action" role="tabpanel" aria-labelledby="pills-oder-action-tab">
            
            <app-order-actions></app-order-actions>   
        </div>
    </div>

   
</div>




